import axios from "axios";

/**
 * SMS API - Used for SMS-related operations
 * Uses IBAS API endpoint with SMS authorization token
 */
export const SMS_API = axios.create({
  baseURL: process.env.VUE_APP_IBAS_API,
  headers: {
    "Content-Type": "application/json",
    Authorization: process.env.VUE_APP_SMS_AUTH_TOKEN,
  },
});

// Add a request interceptor
SMS_API.interceptors.request.use(
  (config) => {
    // You can also add custom headers
    config.headers["timestamp"] = new Date().getTime();
    return config;
  },
  (error) => {
    // Handle the error
    return Promise.reject(error);
  }
);

/**
 * iBAS API - Main business application service
 */
export const IBAS_API = axios.create({
  baseURL: process.env.VUE_APP_IBAS_API,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor
IBAS_API.interceptors.request.use(
  (config) => {
    console.log("Interceptor fired!"); // Debugging line
    // You can also add custom headers
    config.headers["timestamp"] = new Date().getTime();

    console.log("S2S");
    return config;
  },
  (error) => {
    // Handle the error
    return Promise.reject(error);
  }
);

/**
 * LOAD API - Load management service
 */
export const LOAD_API = axios.create({
  baseURL: process.env.VUE_APP_LOAD_API,
});

/**
 * Google Maps API Key
 */
export const googleApiKey = process.env.VUE_APP_GOOGLE_API_KEY;

/**
 * LOCATION API - Location and serviceability service
 */
export const LOCATION_API = axios.create({
  baseURL: process.env.VUE_APP_LOCATION_API,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * OTP/SMS Service - One-time password service
 */
export const SMS = axios.create({
  baseURL: process.env.VUE_APP_OTP_API,
  headers: {
    "Content-Type": "application/json",
  },
  auth: {
    username: process.env.VUE_APP_OTP_USERNAME,
    password: process.env.VUE_APP_OTP_PASSWORD,
  },
});

/**
 * NIAP API - Network Integration and Provisioning
 */
export const NIAP = axios.create({
  baseURL: process.env.VUE_APP_NIAP_API,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * BROKER API - Retailer broker service
 */
export const BROKER_API = axios.create({
  baseURL: process.env.VUE_APP_BROKER_API,
  headers: {
    "Content-Type": "application/json",
  },
});
